module.exports = __webpack_public_path__ + "img/image23.f80fcc4d.png";